import React, { Component } from 'react';
import { Row, Col, Card, Button, Container, Form, Table } from "react-bootstrap";
import { graphql } from "react-apollo"
import moment from "moment";
import DateBlock from '../home/DateBlock';
import { gql } from "apollo-boost";
import * as Cookies from "es-cookie"
import { withRouter } from "react-router-dom";
import * as compose from "lodash.flowright";
import { withApollo } from "react-apollo";
import SelectDropDown from '../selectdropdown/SelectDropDown'
import { components } from 'react-select'
import MultiSelect from "react-multi-select-component";
import ReportTableData from './tableData';


const DropdownIndicator = props => {
  return (
    components.DropdownIndicator && (
      <components.DropdownIndicator {...props}>
        <svg height="20" width="20" viewBox="0 0 20 20" aria-hidden="true" focusable="false" className="css-6q0nyr-Svg"><path fill="currentColor" d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"></path></svg>
      </components.DropdownIndicator>
    )
  );
};

class HostelAttendanceReportHome extends Component {
  constructor(props) {
    super(props);
    this.state = {

      branchSearchval: "",
      branchSearch: 0,
      branchError: "",

      buildingSearch: "",
      buildingError: "",
      buildingName: "",

      floorError: "",
      floorSearch: "",
      getFloors: [],
      floorSelectedvalue: [],

      roomError: "",
      roomSearch: "",
      getRooms: [],
      roomSelectedvalue: [],


      loader: 0,
      noDateError: "",
      getBuildingFloorAndRoomDetails: [],

      showTable: false,
      startDateCalender: moment(new Date()).subtract(5, "day").startOf('day').unix(),
      endDateCalender: moment(new Date()).startOf('day').unix(),

    };
  }

  componentDidMount() {
    let branchData = this.props.globals.globalBranches;
    this.setState({
      branchSearchval: {
        value: branchData[0].id,
        label: branchData[0].branch_name
      },
      branchSearch: branchData[0].id
    })
    this.getBuildingCreationDetails(branchData[0].id)
  }

  dropDownGetValues(fieldname) {
    let getArray = [];
    if (fieldname == "branchSearch") {
      this.props.globals.globalBranches.map((stumap) => {
        const newObj = {
          value: stumap.id,
          label: stumap.branch_name
        }
        getArray.push(newObj);
      });
    }
    return getArray;
  }

  selecthandleBranch = (name, value) => {
    if (name == "branchSearch") {
      if (value != "0") {
        let branchSearchData = this.props.globals.globalBranches.find((a) => a.id == value);
        console.log("branchSearchData", branchSearchData);
        this.setState({
          branchSearchval: {
            value: branchSearchData.id,
            label: branchSearchData.branch_name
          },
          branchSearch: branchSearchData.id,
          buildingSearch: "",
          buildingError: "",
          getBuildingFloorAndRoomDetails: [],
          getRooms: [],
          roomSelectedvalue: [],
          getFloors: [],
          floorSelectedvalue: [],
          showTable: "",
        })
        this.getBuildingCreationDetails(value);
      } else {
        this.setState({
          branchSearchval: "",
          branchSearch: 0,
          buildingSearch: "",
          buildingError: "",
          getBuildingFloorAndRoomDetails: [],
          getFloors: [],
          floorSelectedvalue: [],
          getRooms: [],
          roomSelectedvalue: [],
          showTable: "",
        })
      }

    }
    this.setState({ [name]: value });

  }

  getBuildingCreationDetails = async (val) => {
    const result = await this.props.client.query({
      query: gql`
      query($institute_id: Int!, $branch_id: Int!,$fromDate:String,$toDate:String){
        getBuildingCreationDetails(institute_id: $institute_id, branch_id:$branch_id,fromDate:$fromDate,toDate:$toDate) {
            hostel_building_id
            hostel_building_name
            floors_details{
              floor_id
              floor_name
              rooms_details{
                room_id
                room_name
                room_capacity
                capacity_details{
                  edu_student_id
                  attendance_status
                  attended_date
                }
              }
            }
        }
    }
      `,
      variables: {
        institute_id: parseInt(Cookies.get("institutionid")),
        branch_id: parseInt(val),
        fromDate: this.state.startDateCalender.toString(),
        toDate: this.state.endDateCalender.toString(),
      },
      fetchPolicy: 'network-only'
    })
    console.log("data", result.data.getBuildingCreationDetails);
    if (result.data.getBuildingCreationDetails.length > 0) {
      let buildingDetails = result.data.getBuildingCreationDetails;
      if (buildingDetails.length > 0) {
        this.setState({
          getBuildingFloorAndRoomDetails: buildingDetails,
          loader: 0,
          noDateError: ""
        })
      }
    }
  }

  selDate = (e) => {
    this.setState({ toDate: e.target.value })
  }

  handleInputChange = (e) => {
    let name = e.target.name
    let value = e.target.value

    if (name == "buildingSearch") {
      let getFloors = []
      let getRooms = []
      if (value != 0) {
        const selectedBuilding = this.state.getBuildingFloorAndRoomDetails.find(a => a.hostel_building_id == value);
        if (selectedBuilding) {
          selectedBuilding.floors_details.map((item) => {
            let obj = {
              label: item.floor_name,
              value: item.floor_id
            }
            getFloors.push(obj)

          })

          selectedBuilding.floors_details.map((item) => {
            item.rooms_details.map((item1) => {
              let obj = {
                label: item1.room_name,
                value: item1.room_id
              }
              getRooms.push(obj)
            })


          })


          // console.log("gggg", roomData);
          this.setState({
            buildingSearch: value,
            buildingName: selectedBuilding.hostel_building_name,
            buildingError: "",
            floorSearch: "",
            floorError: "",
            roomSearch: "",
            roomError: "",
            getFloors: getFloors,
            getRooms: getRooms,
            floorSelectedvalue: getFloors,
            roomSelectedvalue: getRooms,
            showTable: "",
          })
        } else {
          this.setState({
            buildingSearch: "",
            buildingName: "",
            buildingError: "",
            floorSearch: "",
            floorError: "",
            roomSearch: "",
            roomError: "",
            getFloors: [],
            getRooms: [],
            floorSelectedvalue: [],
            roomSelectedvalue: [],
            showTable: "",
          })
        }
      }
    }
  }

  handleMultipleSelectInputChange = async (e, name) => {
    // console.log("multi", e, name);

    if (name === "floorSearch") {
      let floorSelectedvalue = [];

      console.log("eeeeeee", e);

      if (e.length > 0) {
        for (let i = 0; i < e.length; i++) {
          const floorVal = e[i];
          console.log("multi", floorVal);
          const newObj = {
            label: floorVal.label,
            value: floorVal.value,
          };
          floorSelectedvalue.push(newObj);
        }
        let getRooms = [];


        floorSelectedvalue.map((item2) => {
          let roomsData = this.state.getBuildingFloorAndRoomDetails.filter((item3) => item3.hostel_building_id == this.state.buildingSearch)[0].floors_details.filter((item4) => item4.floor_id == item2.value);
          console.log("roomsData", roomsData);

          roomsData[0].rooms_details.map((item5) => {
            let obj = {
              label: item5.room_name,
              value: item5.room_id
            }
            getRooms.push(obj)

          })
        })


        this.setState({
          floorSelectedvalue: floorSelectedvalue,
          floorError: "",
          roomError: "",
          getRooms: getRooms,
          roomSelectedvalue: getRooms,
          showTable: "",
        });
      } else {
        console.log("elseee");
        this.setState({
          floorSelectedvalue: [],
          getRooms: [],
          roomSelectedvalue: [],
          floorError: "",
          roomError: "",
          showTable: "",
        });
      }
    }

    if (name === "roomSearch") {
      let roomSelectedvalue = [];

      if (e.length > 0) {
        for (let i = 0; i < e.length; i++) {
          const roomVal = e[i];
          console.log("roomVal", roomVal);
          const newObj = {
            label: roomVal.label,
            value: roomVal.value,
          };
          roomSelectedvalue.push(newObj);
        }
        this.setState({
          roomSelectedvalue: roomSelectedvalue,
          floorError: "",
          roomError: "",
          showTable: "",
        });
      } else {
        this.setState({
          roomSelectedvalue: [],
          floorError: "",
          roomError: "",
          showTable: "",
        });
      }
    }
  }

  getDisplayData = (e) => {
    e.preventDefault();

    if (this.state.buildingSearch == "") {
      this.setState({ buildingError: "Please select Building" })
      return ""
    }
    if (!this.state.floorSelectedvalue.length) {
      this.setState({ floorError: "Please select Floor" })
      return ""
    }
    if (!this.state.roomSelectedvalue.length) {
      this.setState({ roomError: "Please select Room" })
      return ""
    }
    this.setState({ showTable: true });
  }

  applyCallback = (startDate, endDate) => {
    console.log("nnnn", startDate, endDate);
    this.setState({
      startDateCalender: startDate.startOf('day').unix(),
      endDateCalender: endDate.startOf('day').unix(),

      buildingSearch: "",
      buildingError: "",
      buildingName: "",

      floorError: "",
      floorSearch: "",
      getFloors: [],
      floorSelectedvalue: [],

      roomError: "",
      roomSearch: "",
      getRooms: [],
      roomSelectedvalue: [],

      loader: 0,
      noDateError: "",
      showTable: false,
      getBuildingFloorAndRoomDetails: [],
    })



    setTimeout(() => {
      this.getBuildingCreationDetails(this.state.branchSearch);
    }, 100)



  }

  render() {
    console.log("maheshprops", this.props);
    console.log("maheshstate", this.state);

    let floorselectall = true;
    let floorlabelledBy = "Select";
    let floordisableSearch = false;

    if (this.state.getFloors.length > 0) {
      floorselectall = true;
      floordisableSearch = false;
    }
    else {
      floordisableSearch = true;
      floorselectall = false;
      floorlabelledBy = "Select Floor"
    }


    let roomselectall = true;
    let roomlabelledBy = "Select";
    let roomdisableSearch = false;

    if (this.state.getRooms.length > 0) {
      roomselectall = true;
      roomdisableSearch = false;
    }
    else {
      roomdisableSearch = true;
      roomselectall = false;
      roomlabelledBy = "Select Room"
    }



    return (
      <section className="attendance_report">
        <Container>

          <Row>
            <Col xl={12} lg={12} md={12} sm={12}>
              <div className="breadcrumb_section border-bottom border-theme pb-1 my-4 d-flex align-items-center justify-content-between">
                <h2 className="title h5 mb-0">Hostel Attendance Report</h2>

                <div className="filter-block d-flex align-items-center mr-4">
                  <Form.Group className="customDate mb-0 mr-4" controlId="StartDate" style={{ width: 180 }}>
                    <DateBlock applyCallback={this.applyCallback} start={this.start} end={this.end}
                      stateData={this.props.stateData} data="hostel_Attendance_Report"
                    />
                  </Form.Group>
                </div>
              </div>
            </Col>
            <Col xl={12} lg={12} md={12} sm={12}>
              <Form>
                <Form.Row>
                  <Form.Group as={Col} lg={2} md={12} sm={12} controlId="SelectClass">
                    <Form.Label className="text-uppercase font-weight-bold">Branch</Form.Label>
                    <SelectDropDown
                      stateData={this.state.branchSearchval}
                      handleChange={this.selecthandleBranch}
                      name="branchSearch"
                      options={this.dropDownGetValues("branchSearch")}
                      placeholderName={'Branch'}
                      dropdownIndicator={{ DropdownIndicator }}
                    />
                    <Form.Text className="form-text text-danger">
                      {this.state.branchError}
                    </Form.Text>
                  </Form.Group>


                  <Form.Group as={Col} lg={2} md={12} sm={12} controlId="Selectexam">
                    <Form.Label className="text-uppercase font-weight-bold">Building</Form.Label>
                    <Form.Control as="select" name="buildingSearch" onChange={this.handleInputChange} value={this.state.buildingSearch}>
                      <option value={this.state.defaultvalue}>--Select--</option>
                      {this.state.getBuildingFloorAndRoomDetails.map(buildname => (
                        <option value={buildname.hostel_building_id}>{buildname.hostel_building_name}</option>
                      ))}
                    </Form.Control>
                    <Form.Text className="form-text text-danger">
                      {this.state.buildingError}
                    </Form.Text>

                  </Form.Group>


                  <Form.Group as={Col} lg={2} md={12} sm={12} controlId="SelectClass">
                    <Form.Label className="text-uppercase font-weight-bold">Floor</Form.Label>
                    <MultiSelect
                      overrideStrings={{
                        "allItemsAreSelected": "All floors are selected.",
                        "selectSomeItems": floorlabelledBy
                      }
                      }
                      disableSearch={floordisableSearch}
                      hasSelectAll={floorselectall}
                      options={this.state.getFloors}
                      value={this.state.floorSelectedvalue}
                      onChange={(e) => this.handleMultipleSelectInputChange(e, "floorSearch")}
                      labelledBy={"floorSearch"}
                    />
                    <Form.Text className="form-text text-danger">
                      {this.state.floorError}
                    </Form.Text>
                  </Form.Group>

                  <Form.Group as={Col} lg={2} md={12} sm={12} controlId="SelectClass">
                    <Form.Label className="text-uppercase font-weight-bold">Rooms</Form.Label>
                    <MultiSelect
                      overrideStrings={{
                        "allItemsAreSelected": "All rooms are selected.",
                        "selectSomeItems": roomlabelledBy
                      }
                      }
                      disableSearch={roomdisableSearch}
                      hasSelectAll={roomselectall}
                      options={this.state.getRooms}
                      value={this.state.roomSelectedvalue}
                      onChange={(e) => this.handleMultipleSelectInputChange(e, "roomSearch")}
                      labelledBy={"roomSearch"}
                    />
                    <Form.Text className="form-text text-danger">
                      {this.state.roomError}
                    </Form.Text>
                  </Form.Group>

                  <Form.Group as={Col} lg={4} md={12} sm={12} controlId="Selectexam">
                    <Button className="btn btn-success text-uppercase submit_btn" onClick={this.getDisplayData}>Get Report</Button>
                  </Form.Group>
                </Form.Row>
              </Form>
            </Col>
          </Row>

          {
            this.state.showTable && this.state.getBuildingFloorAndRoomDetails.length > 0 ? (

              <Container>
                <Row className='mt-3 ' >
                  <Col as={Col} lg={10} md={12} sm={12} className="h6 text-center">Attendance Results</Col>
                </Row>
                <ReportTableData stateData={this.state} globals={this.props.globals} buildingDetails={this.state.getBuildingFloorAndRoomDetails} getNewEducationalStudents={this.props.getNewEducationalStudents} />
              </Container>
            ) :
              (
                <Row>
                  <Col sm={12}>
                    <div className={this.state.loader == 1 ? "d-flex align-items-center spinner-border text-primary text-center loading-img-center" : ""}></div>
                  </Col>
                  <Col sm={12}>
                    {
                      this.state.noDateError != "" ?
                        (
                          <h6 className='d-flex justify-content-center align-content-center'>{this.state.noDateError}</h6>
                        )
                        :
                        ("")
                    }
                  </Col>
                </Row>
              )
          }

        </Container>

      </section>
    );
  }
}
export default withRouter(withApollo(HostelAttendanceReportHome));
